var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "/invoice-disputes/index" } } },
            [_vm._v(_vm._s(_vm.$t("invoice-disputes.title")))]
          ),
          _vm._v(" "),
          _vm.recipientRecord
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: {
                      name: "recipient-detail",
                      params: {
                        id: _vm.recipient,
                        participant: _vm.selectedParticipantStore
                      }
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.recipientRecord.name) + "\n\t\t")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-card",
                [
                  _c("div", { staticClass: "hbar" }, [_c("Filters")], 1),
                  _vm._v(" "),
                  _c("invoice-disputes-table", {
                    ref: "table",
                    attrs: {
                      "legal-entity": _vm.legalEntity,
                      recipient: _vm.recipient,
                      invoices: _vm.invoices
                    },
                    on: {
                      change: function($event) {
                        return _vm.$apollo.queries.tasks.refresh()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.recipientRecord
        ? _c(
            "el-row",
            { staticClass: "mt-5", attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 17 } },
                [
                  _c(
                    "el-card",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              [
                                _c("h3", { staticClass: "mb-20" }, [
                                  _vm._v(_vm._s(_vm.recipientRecord.name))
                                ]),
                                _vm._v(" "),
                                _c("MainContacts", {
                                  attrs: {
                                    recipient: _vm.recipientRecord.reference,
                                    "legal-entity":
                                      _vm.recipientRecord.legal_entity
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.recipientRecord &&
                            _vm.recipientRecord.custom_fields
                              ? _c(
                                  "div",
                                  [
                                    _c("h4", { staticClass: "mt-20 mb-10" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("shared.custom_fields"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.userInterfaceDetails &&
                                    _vm.userInterfaceDetails
                                      .custom_field_definitions
                                      ? _c("custom-fields-list", {
                                          attrs: {
                                            "custom-field-definitions":
                                              _vm.userInterfaceDetails
                                                .custom_field_definitions,
                                            "custom-fields":
                                              _vm.recipientRecord.custom_fields
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mb-10",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            _vm.showCustomFields = !_vm.showCustomFields
                                          }
                                        }
                                      },
                                      [
                                        _vm.showCustomFields
                                          ? _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "shared.hide_custom_fields"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "shared.show_custom_fields"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showCustomFields
                                      ? _c("json-editor", {
                                          attrs: {
                                            value:
                                              _vm.recipientRecord.custom_fields
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("h4", { staticClass: "mb-10" }, [
                              _vm._v(
                                _vm._s(_vm.$t("invoice-disputes.attachments"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "attachments" },
                              [
                                _vm._l(_vm.recipientAttachments, function(
                                  attachment,
                                  index
                                ) {
                                  return _c(
                                    "el-button",
                                    {
                                      key: index,
                                      attrs: { type: "text" },
                                      on: { click: _vm.handleAttachments }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(attachment.name) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-5",
                                    attrs: { type: "text" },
                                    on: { click: _vm.handleAttachments }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t+ " +
                                        _vm._s(
                                          _vm.$t(
                                            "invoice-disputes.no_attachments"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-20 mb-10" }, [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.$tc("contact", 777)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "contacts" },
                              [
                                _vm.recipientRecord &&
                                _vm.recipientRecord.reference
                                  ? [
                                      _c("contacts", {
                                        attrs: {
                                          recipient:
                                            _vm.recipientRecord.reference,
                                          "legal-entity":
                                            _vm.recipientRecord.legal_entity,
                                          "allow-edit": _vm.allowEditContacts,
                                          selectable: false
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex" })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "pr-15 pb-15",
                        staticStyle: {
                          "overflow-y": "scroll",
                          "max-height": "85vh"
                        }
                      },
                      [
                        _c("actions-notes", {
                          attrs: { recipient: _vm.recipientRecord }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("attachments-dialog", {
        attrs: {
          visible: _vm.attachmentsDialogVisible,
          participant: _vm.$store.state.risolto.selectedParticipantStore,
          "legal-entity": _vm.legalEntity,
          "file-list": _vm.recipientAttachments,
          "on-upload": _vm.handleAttachmentUpload,
          "on-remove": _vm.handleAttachmentRemove
        },
        on: {
          "dialog-close": function($event) {
            _vm.attachmentsDialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }